// extracted by mini-css-extract-plugin
export default {"MenuItem":"MenuItem_MenuItem__YHu+o","MenuItem-content":"MenuItem_MenuItem-content__DkroS","MenuItem-headline":"MenuItem_MenuItem-headline__9ZzQB"};